import { cn, Stack } from 'component-library';
import React, { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'react-map-gl';

type ProjectMapCoordinatePopupProps = {
  lat: number;
  lng: number;
  onClose: () => void;
};

export const ProjectMapCoordinatePopup: FC<ProjectMapCoordinatePopupProps> = ({ lat, lng, onClose }) => {
  const { t } = useTranslation();

  return (
    <Popup
      longitude={lng}
      latitude={lat}
      closeButton={false}
      closeOnClick={false}
      anchor='top'
      onClose={onClose}
      className='popup-shadow z-1'
      maxWidth='420px'
      offset={8}
    >
      <div className='rounded-xl bg-white-100 p-4'>
        <button
          onClick={onClose}
          className='absolute right-2 top-2 text-neutral-500 hover:text-neutral-700'
          aria-label='Close'
        >
          ×
        </button>
        <Stack spacing={6}>
          <InfoBox>
            <InfoTitle>{t('shared.projects.map.popup.labels.latitude')}</InfoTitle>
            <InfoText>{lat.toFixed(8)}</InfoText>
          </InfoBox>
          <InfoBox>
            <InfoTitle>{t('shared.projects.map.popup.labels.longitude')}</InfoTitle>
            <InfoText>{lng.toFixed(8)}</InfoText>
          </InfoBox>
        </Stack>
      </div>
    </Popup>
  );
};

// Reuse the same UI conventions as the existing popup
const InfoBox = ({ children }: { children: React.ReactNode }) => <Stack className='min-w-0 gap-2'>{children}</Stack>;

const InfoTitle: FC<HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
  <span className={cn('typography-overline block text-left text-text-disabled', className)} {...props} />
);

const InfoText: FC<HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
  <span className={cn('typography-h4 block truncate whitespace-nowrap text-left', className)} {...props} />
);
